// extracted by mini-css-extract-plugin
module.exports = {"card":"FAQAccordionToggle_card__1ljEG","accordian-toggle-arrow":"FAQAccordionToggle_accordian-toggle-arrow__1Mg5Z","active":"FAQAccordionToggle_active__Dq6F2"};